import { type ReactNode } from 'react'

import { PageTitle } from '@/components/ui/page-title'
import { cn } from '@/lib/utils'

/** Dashboard preview section heading — 20px, not full in-route `PageTitle` scale. */
export const DASHBOARD_SECTION_TITLE_CLASS =
  'text-[20px] font-semibold tracking-tight text-foreground'

export type DashboardSectionTitleProps = {
  id: string
  title: ReactNode
  /** Top-right action (button, link, etc.). */
  action?: ReactNode
  className?: string
}

/** Title row for dashboard preview sections (heading + optional action). */
export function DashboardSectionTitle({ id, title, action, className }: DashboardSectionTitleProps) {
  return (
    <div
      className={cn(
        'flex flex-wrap items-center justify-between gap-x-4 gap-y-2',
        className,
      )}
    >
      <div className="min-w-0">
        <PageTitle id={id} className={DASHBOARD_SECTION_TITLE_CLASS}>
          {title}
        </PageTitle>
      </div>
      {action ? <div className="ml-auto shrink-0">{action}</div> : null}
    </div>
  )
}
